import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/offer';
import type { FAQItem } from '../types/content';
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-58" data-mp="1ccdpgsksnqvs">
      <div className="overflow-hidden rounded-2xl border border-navy/10 bg-surface shadow-premium" data-id="element-59" data-mp="2a2s2e9gwcdwo">
        <button type="button" className="flex w-full items-center gap-4 p-5 text-left transition-colors duration-200 hover:bg-mist focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sage sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-60" data-mp="252maqtammrel">
          <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-61" data-mp="oqgw4xqysvvy">
            ?
          </span>
          <span className="flex-1 font-semibold text-navy" data-id="element-62" data-mp="1klni6426w6jg">{item.question}</span>
          <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-sage transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-63" data-mp="1pmb9kqubype7" />
        </button>
        <AnimatePresence initial={false} data-id="element-64" data-mp="1fn2ic5qunovj">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-65" data-mp="11wz0dqz06hbw">
              <p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-66" data-mp="rx869qecu4cc">{item.answer}</p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-67" data-mp="n080lglf33lr">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="2pmn39s4xdny1">
        <Reveal className="text-center" data-id="element-69" data-mp="2pnoq0tvazyvl">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-70" data-mp="2poq3t63pezh0">
            ❓ Domande <span className="text-sage" data-id="element-71" data-mp="2kuc0mhisvo1s">Frequenti</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-72" data-mp="2fw2525t5ylfn">Tutto ciò che devi sapere prima di acquistare.</p>
        </Reveal>
        <div className="mt-10 space-y-3" data-id="element-73" data-mp="2ays9e8f6ldjd">
          {faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-74" data-mp="38lraqwgtj9nl" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}